
import Vue from 'vue';
import { message, notification } from 'ant-design-vue';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { GET } from './http';

const Common = {
  /**
   *  数据保存到localStorage
   * @param key
   * @param value
   */
  setLocal (key, value) {
    if (value === undefined || key === undefined) {
      return;
    }
    if (typeof value === 'number' || typeof value === 'string') {
      localStorage[key] = value;
    } else if (typeof value === 'object' && value !== null) {
      localStorage[key] = JSON.stringify(value);
    }
  },

  /**
   * 获取localStorage数据
   * @param key
   * @returns {any}
   */
  getLocal (key) {
    if (!localStorage[key]) {
      return;
    }
    let value = localStorage[key];
    let index1 = value.indexOf('[');
    let index2 = value.indexOf('{');
    if (index1 >= 0 || index2 >= 0) {
      value = JSON.parse(localStorage[key]);
    }
    return value;
  },
  /**
   * 消息提示
   */
  message (param) {
    let type = param['type'] || 'success';
    message[type](param['message'] || '消息提示', param['duration'] || 3, param.callback);
  },
  /**
   * 清空搜索条件
   * @param selectData 重置对象
   * @param excludeKey 不重置的字段
   */
  resetData (selectData, excludeKey = []) {
    if (selectData && Object.keys(selectData).length) {
      let arr = ['page', 'pagesize', 'app_type']; // app_type单独处理社区、管家app菜单
      excludeKey.length && (arr = [...arr, ...excludeKey]);
      for (let item in selectData) {
        if (arr.every(el => el !== item)) {
          if (Array.isArray(selectData[item])) {
            selectData[item] = [];
          } else if (typeof selectData[item] !== 'undefined') {
            selectData[item] = undefined;
          }
        }
      }
    }
    return selectData;
  },
  /**
   *  过滤value为空的参数
   * @param obj
   */
  filterParam (obj) {
    var paramObj = {};
    for (var i in obj) {
      if (obj[i] !== '' && (obj[i] !== undefined)) {
        paramObj[i] = obj[i];
      }
    }
    return paramObj;
  },
  /**
   *  处理更多筛选的数据
   * @param val
   * @param searchParams
   * @param searchKey
   */
  transformSelectParam (val, searchParams, searchKey) {
    for (let key in val) {
      if (searchParams.hasOwnProperty(key)) {
        searchParams[key] = val[key];
      }
    }
  },
  /**
   *  获取数组最后一项
   * @param formData
   * @param key
   * @returns {any}
   */
  getLastIndex (formData, key) {
    let data = JSON.parse(JSON.stringify(formData));
    let item = data[key];
    item.length && (data[key] = item[item.length - 1]);
    return data;
  },
  /**
   * 隐藏手机号中间四位
   * @param mobile
   * @returns {string}
   */
  hideMobileNum (mobile) {
    return mobile && `${mobile.slice(0, 3)}****${mobile.slice(7)}`;
  },
  /* date picker 禁用时间范围 */
  disabledDate (date) {
    return date < moment(new Date());
  },
  /* 检测网络状态 */
  netWorkStatus () {
    let img = new Image();
    img.src = require('../assets/logo.png');
    img.onload = function (e) {
    };
    img.onerror = function (e) {
      notification.error({ message: '网络连接异常' });
    };
  },
  /* 获取access token */
  getToken () {
    GET({
      url: '/access_token',
      params: { grant_type: 'client_credential' }
    }).then(({data}) => {
      let docToken = document.cookie.split('=')[1];
      if (!docToken) {
        document.cookie = `accessToken=${data.access_token};max-age=1800`;
      }
    });
  },
  /**
   *  查看图片
   * @param url
   */
  showPicture (url) {
    if (url) {
      window.open(url);
    } else {
      this.$message.error('图片地址为空');
    }
    // let waterUrl = this.waterMark({
    //   url: url,
    //   txt: '浩邈社区',
    //   // selector: 'myImg',
    //   xNum: 8,
    //   xDistance: 70,
    //   xAdd: 2,
    //   yNum: 12,
    //   yDistance: 50
    // });
    // if (waterUrl) {
    //   window.open(waterUrl);
    // } else {
    //   this.$message.error('图片地址为空');
    // }
  },
  /* 制作水印 */
  waterMark (param) {
    const img = new Image();
    img.src = 'http://haomiao-test.oss-cn-beijing.aliyuncs.com/open-2019-11-100089-66-1572833774.webp?OSSAccessKeyId=LTAI4FsAcNV64mWAfoUDPtzz&Expires=1572837736&Signature=wX12j5RF781BTvLrhVNsBYwZ2OY%3D'; // 图片url地址
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = '12px Microsoft Yahei';
      ctx.fillStyle = 'rgba(184, 184, 184, 1)';
      ctx.rotate(-30 * Math.PI / 180);

      let arr = [];
      for (let i = 0 - param.xAdd; i < param.xNum; i++) { // 35 得到x方向循环个数的基数
        arr.push(i * param.xDistance); // 0.4 得到x方向间距的基数
      }
      arr.forEach((el) => {
        this.fillText(el, param, ctx);
      });
      const base64Url = canvas.toDataURL();
      if (param.selector) {
        document.getElementsByClassName(param.selector)[0].src = base64Url; // 展示的位置
      } else {
        return base64Url;
      }
    };
  },
  fillText (x, param, ctx) {
    for (let i = 0; i < param.yNum; i++) { // 50 得到y方向循环个数的基数
      let y = i * param.yDistance; // 4 得到y方向间距的基数
      ctx.fillText(param.txt, x, y);
    }
  },
  /**
   * 根据天气code返回icon
   * @param code
   * @returns {*}
   */
  getWeatherIcon (code) {
    let weatherDict = {
      '100': {txt: '晴', icon: '100'},
      '101': {txt: '多云', icon: '101'},
      '102': {txt: '少云', icon: '102'},
      '103': {txt: '晴间多云', icon: '103'},
      '104': {txt: '阴', icon: '104'},
      '200': {txt: '有风', icon: '200'},
      '201': {txt: '平静', icon: '201'},
      '202': {txt: '微风', icon: '202'},
      '203': {txt: '和风', icon: '203'},
      '204': {txt: '清风', icon: '204'},
      '205': {txt: '强风/劲风', icon: '205'},
      '206': {txt: '疾风', icon: '206'},
      '207': {txt: '大风', icon: '207'},
      '208': {txt: '烈风', icon: '208'},
      '209': {txt: '风暴', icon: '209'},
      '210': {txt: '狂爆风', icon: '210'},
      '211': {txt: '飓风', icon: '211'},
      '212': {txt: '龙卷风', icon: '212'},
      '213': {txt: '热带风暴', icon: '213'},
      '300': {txt: '阵雨', icon: '300'},
      '301': {txt: '强阵雨', icon: '301'},
      '302': {txt: '雷阵雨', icon: '302'},
      '303': {txt: '强雷阵雨', icon: '303'},
      '304': {txt: '雷阵雨伴有冰雹', icon: '304'},
      '305': {txt: '小雨', icon: '305'},
      '306': {txt: '中雨', icon: '306'},
      '307': {txt: '大雨', icon: '307'},
      '308': {txt: '极端降雨', icon: '308'},
      '309': {txt: '毛毛雨/细雨', icon: '309'},
      '310': {txt: '暴雨', icon: '310'},
      '311': {txt: '大暴雨', icon: '311'},
      '312': {txt: '特大暴雨', icon: '312'},
      '313': {txt: '冻雨', icon: '313'},
      '314': {txt: '小到中雨', icon: '314'},
      '315': {txt: '中到大雨', icon: '315'},
      '316': {txt: '大到暴雨', icon: '316'},
      '317': {txt: '暴雨到大暴雨', icon: '317'},
      '318': {txt: '大暴雨到特大暴雨', icon: '318'},
      '399': {txt: '雨', icon: '399'},
      '400': {txt: '小雪', icon: '400'},
      '401': {txt: '中雪', icon: '401'},
      '402': {txt: '大雪', icon: '402'},
      '403': {txt: '暴雪', icon: '403'},
      '404': {txt: '雨夹雪', icon: '404'},
      '405': {txt: '雨雪天气', icon: '405'},
      '406': {txt: '阵雨夹雪', icon: '406'},
      '407': {txt: '阵雪', icon: '407'},
      '408': {txt: '小到中雪', icon: '408'},
      '409': {txt: '中到大雪', icon: '409'},
      '410': {txt: '大到暴雪', icon: '410'},
      '499': {txt: '雪', icon: '499'},
      '500': {txt: '薄雾', icon: '500'},
      '501': {txt: '雾', icon: '501'},
      '502': {txt: '霾', icon: '502'},
      '503': {txt: '扬沙', icon: '503'},
      '504': {txt: '浮尘', icon: '504'},
      '507': {txt: '沙尘暴', icon: '507'},
      '508': {txt: '强沙尘暴', icon: '508'},
      '509': {txt: '浓雾', icon: '509'},
      '510': {txt: '强浓雾', icon: '510'},
      '511': {txt: '中度霾', icon: '511'},
      '512': {txt: '重度霾', icon: '512'},
      '513': {txt: '严重霾', icon: '513'},
      '514': {txt: '大雾', icon: '514'},
      '515': {txt: '特强浓雾', icon: '515'},
      '900': {txt: '热', icon: '900'},
      '901': {txt: '冷', icon: '901'},
      '999': {txt: '未知', icon: '999'}
    };
    return weatherDict[code].icon;
  },
  /**
   * 列表轮播
   * @param obj
   */
  carousel (obj) {
    obj.interval = setInterval(() => {
      obj.isScroll = true;
      let timeout = setTimeout(() => {
        let first = obj.list[0];
        obj.list.push(first);
        obj.list.shift();
        obj.isScroll = false;
        clearTimeout(timeout);
      }, 1200);
    }, 2000);
  },
  /**
   * 补全长度小于6的数组
   * @param arr
   * @returns {*}
   */
  replenishList (arr) {
    let len = arr.length;
    if (len && len < 6) {
      let less = 6 - len;
      if (less < len) {
        arr.push(...arr.slice(0, less));
      } else { // less >= len
        let num = Math.ceil(less / len);
        let arr1 = JSON.parse(JSON.stringify(arr));
        for (let i = 0; i < num; i++) {
          arr.push(...arr1);
        }
      }
    }
    return arr;
  },
  /**
   * 定时器间隔时长
   * @returns {number}
   */
  intervalTime () {
    return 1000 * 60 * 20; // 20分钟
  },
  /**
   * 返回数组指定key选项的index
   * @param list
   * @param key
   * @returns {number}
   */
  gainListIndex (list, key) {
    if (!Array.isArray(list)) {
      return;
    }
    for (let i = 0; i < list.length; i++) {
      let el = list[i];
      let props = el.props && el.props[0];
      if (props === key) {
        return i;
      }
    }
  },
  /** 创建input提示信息 */
  generateExtra (valContent, unique) {
    let extra = [];
    for (let item in valContent) {
      extra.push(valContent[item]);
    }
    extra = `值范围: ${extra.join('-')}`;

    let unitObj = {
      'PASSWORD_EXPIRE_MINUTE': 'min',
      'DELAY': 's',
      'OPEN_DELAYTIME': 's'
    };
    extra = unitObj[unique] ? `${extra}${unitObj[unique]}` : extra;
    return extra;
  }
};

for (let item in Common) {
  Vue.prototype[item] = Common[item];
}

export default Common;



// WEBPACK FOOTER //
// ./src/js/common.js